import type { AxiosResponse } from 'axios';

import { apiProducer } from '~/configs/api/apiConfig';
import type { IFeatureFlag } from '~/stores/featureFlags/useFeatureFlagStore';

type IParams = {
  flag: string;
};

type IResponse = AxiosResponse<boolean>;

export const getFeatureFlag = async (params: IParams): Promise<IFeatureFlag> => {
  const response: IResponse = await apiProducer.get(`/feature-flag/${params.flag}`);

  return {
    name: params.flag,
    isEnabled: response.data,
  };
};

type IEmailParams = {
  flag: string;
  email: string;
};

export const getFeatureFlagByEmail = async (params: IEmailParams): Promise<IFeatureFlag> => {
  const flagKey = `${params.flag}:${params.email}`;
  const response: IResponse = await apiProducer.get(`/feature-flag/${flagKey}`);

  return {
    name: flagKey,
    isEnabled: response.data,
  };
};
